var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"column"},[_c('iframe',{staticClass:"col",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.publicComponentSrc,"frameBorder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }